<template>
  <div class="wrap">

    <!-- <Home v-if="show" /> -->
    <Start v-if="!show" @back="onBack" />

  </div>
</template>

<script>
// import {gsap} from 'gsap'¡
// import $ from 'jquery'
// import Nav from '../components/Nav.vue'
// import Footer from '../components/Footer.vue'
import Start from '../components/Start.vue'
// import Home from '../components/Home.vue'
export default {
  data() {
    return {
        show: false,
        navList: ['首页', '公司简介', '产品简介', '联系我们'],
        translateX: 0
    }
  },
  components: {
    Start
  },
  created() {
  },
  mounted() {
    // this.setUnderLine();
    // $('.nav-btm-line').css({
    //   left: 0 + 'px'
    // });
    // let bar = document.getElementById('bar')
    // var barOffSetTop = document.getElementById('bar').offsetTop
    // window.addEventListener('scroll', () => {
    //   if(barOffSetTop < document.body.scrollTop){
    //     bar.classList.add('add-fixed')
    //   }else{
    //     bar.classList.remove('add-fixed')
    //   }
    // });
  },
  methods: {
    onBack() {
      this.show = true;
    },
    // changeTitle(index) {
    //   this.active = index;
    //   this.setUnderLine();
    // },
    // setUnderLine() {
    //   // 屏幕宽
    //   let width = document.documentElement.clientWidth;
    //   // 每个菜单所占宽度 = 屏宽 / 菜单个数
    //   let slidingWidth = (width / this.navList.length).toFixed(2);
    //   // 半个菜单宽度 （为了将下划线与菜单对齐）
    //   let halfSlidingWidth = (slidingWidth / 2).toFixed(2);
    //   // 水平位移目的坐标 = 半个菜单宽度 + (菜单宽 x 当前所在的index)
    //   this.translateX = Number(halfSlidingWidth) + Number(slidingWidth * this.active);
    // }
  } 
};
</script>

<style scoped lang="less">
</style>